<template>
    <div
        v-if="active"
        class="modal"
        v-bind:class="{ 'is-active' : active }"
    >
        <div
            class="modal-background"
            @click="localClose"
        ></div>
        <div
            v-if="!isCard"
            class="modal-content"
            :class="contentClass"
        >
            <slot></slot>
        </div>
        <div
            v-if="isCard"
            class="modal-card"
            :class="contentClass"
        >
            <div
                class="modal-card-head"
                v-if="$slots['header']"
            >
                <slot name="header"></slot>
            </div>
            <div class="modal-card-body">
                <slot></slot>
            </div>
            <div
                class="modal-card-foot"
                v-if="$slots['footer']"
            >
                <slot name="footer"></slot>
            </div>
        </div>
        <button
            class="modal-close is-large"
            aria-label="close"
            @click="localClose"
        ></button>
    </div>
</template>

<script>
export default {
    name : 'modal',
    inject : ['$validator'],
    props : {
        active : {
            type : Boolean,
            required : true,
        },
        close : {
            type : Function,
            required : false,
        },
        isLarge : {
            type : Boolean,
            required : false,
            default : false,
        },
        isExtraLarge : {
            type : Boolean,
            required : false,
            default : false,
        },
        noPadding : {
            type : Boolean,
            required : false,
            default : false,
        },
        isCard : {
            type : Boolean,
            required : false,
            default : false,
        },
    },
    computed : {
        contentClass () {
            return {
                'is-large' : this.isLarge,
                'is-xlarge' : this.isExtraLarge,
                'p-n' : this.noPadding,
            }
        },
    },
    methods : {
        localClose () {
            if(this.close){
                this.close();
            }
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../assets/css/_theme';
    .modal-content {
        padding:20px;
        background-color:$white;
        border-radius:5px;
        &.is-large {
            width:900px;
        }
        &.is-xlarge {
            width:1200px;
        }
    }
    /deep/ .modal-header {
        background-color:$white-ter;
        margin:-20px -20px 20px -20px;
        padding:10px 20px;
    }

    /deep/ .modal-card-foot > div {
        width:100%;
    }
</style>
